import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tu_schedule_color_ok",
  "use": "icon-tu_schedule_color_ok-usage",
  "viewBox": "0 0 13 9",
  "content": "<symbol viewBox=\"0 0 13 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tu_schedule_color_ok\">\n<path d=\"M1 3.5L5 7.5L11.5 1\" stroke=\"\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol